import { useParams } from 'react-router-dom';
import { useConsultationDevis } from '../../../../../../hooks/fetchers/useConsultationDevis/useConsultationDevis';
import DashboardLayout from '../../../../../commons/DashboardLayout/DashboardLayout';
import Button from '../../../../../designSystem/Button/Button';
import { downloadDevis } from './DashboardHistoryPUBDevis.query';

export default () => {
  const { consultationId } = useParams();

  const { data } = useConsultationDevis(parseInt(consultationId as string), {
    enabled: Boolean(consultationId),
  });

  return (
    <DashboardLayout>
      <table className="dashboard__table dashboard-invoices__table">
        <colgroup>
          <col style={{ width: '45%' }} />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th>Entreprise</th>
            <th>Localisation</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.map(({ name, city, department, region, id_consultation_match }, index) => {
            return (
              <tr key={index}>
                <td>{name}</td>
                <td>
                  {city}, {department}, {region}
                </td>
                <td>
                  <Button
                    onClick={() =>
                      downloadDevis(parseInt(consultationId as string), id_consultation_match)
                    }>
                    Télécharger le devis
                  </Button>
                </td>
                {/* <td>{id_step}</td> */}
              </tr>
            );
          })}
        </tbody>
      </table>
    </DashboardLayout>
  );
};
